module.exports = __webpack_public_path__ + "static/engineering2-zig-zag5-04913e486e0dec0ad992b1729ef274a8.png";